module.exports = __webpack_public_path__ + "img/1.c89a8c02.jpg";